import base from "/opt/buildhome/repo/images/genius-active.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");